
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.442 8.016c-.84 0-1.651.305-2.283.859V5.566A.575.575 0 00.58 5a.575.575 0 00-.58.57v5.833a3.418 3.418 0 003.442 3.388 3.387 3.387 0 000-6.775zm0 5.633a2.247 2.247 0 112.284-2.246 2.268 2.268 0 01-2.284 2.25m6.958.902a3.137 3.137 0 11-.01-6.274 3.137 3.137 0 01.01 6.274zm0-5.622a2.486 2.486 0 10-.01 4.973 2.486 2.486 0 00.01-4.973m6.62-.488a2.974 2.974 0 11-2.97 2.974V5.246a.163.163 0 01.325 0v4.827a2.967 2.967 0 012.645-1.628zm0 5.622a2.649 2.649 0 10.01-5.298 2.649 2.649 0 00-.008 5.298","fill":"#4A4A4A"}})])
          )
        }
      }
    